import { createContext } from 'react';
import type { UiStateAction } from './uiStateReducer';

export interface IUiState {
    bannerHeight: number;
    isAskEmploymentForSpecializationsModalOpen: boolean;
    isFeedbackModalOpen: boolean;
    isSupportModalOpen: boolean;
    isTopBarOpen: boolean;
}

type Dispatch = (action: UiStateAction) => void;

export const UiStateContext = createContext<{ dispatchUiStateAction: Dispatch; uiState: IUiState } | undefined>(
    undefined
);
